import { useState, useEffect } from "react";
import { X, Copy, Check } from "lucide-react";
import { LightningBolt } from "./BrandAccents";

const STORAGE_KEY = "snip_promo_dismissed_v1";

export default function PromoBanner() {
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText("SNIPHAPPENS10");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {/* ignore */}
  };

  if (!visible) return null;

  return (
    <div data-testid="promo-banner" className="relative bg-[#1c1815] text-white">
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center justify-center gap-3 text-[11px] sm:text-xs font-bold uppercase tracking-[0.22em] text-center">
        <LightningBolt size={14} className="hidden sm:inline-block opacity-90"/>
        <span>10% off your first — code</span>
        <button onClick={copy} data-testid="copy-promo" className="inline-flex items-center gap-1.5 bg-[#e8478e] text-white px-2.5 py-1 rounded-md hover:bg-[#c93875] transition-all">
          <span className="font-mono tracking-widest">SNIPHAPPENS10</span>
          {copied ? <Check size={12} className="text-white"/> : <Copy size={12}/>}
        </button>
        <span className="hidden md:inline text-[#2eb6a8]">· spend $50+ → 20% off your next</span>
      </div>
      <button
        onClick={dismiss}
        data-testid="dismiss-promo"
        aria-label="Dismiss promo"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 hover:bg-white/10 rounded-full"
      >
        <X size={14}/>
      </button>
    </div>
  );
}
